module.exports = __webpack_public_path__ + "img/coir-board.b2cfdb65.jpg";